{
  "mode": "Режим",
  "theme": "Тема"
}
